import { CommonModule } from '@angular/common';
import { Component, HostBinding, input, numberAttribute } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  imports: [CommonModule],
})
export class Skeleton {
  @HostBinding('style') get hostStyle() {
    return {
      height: `${this.height()}px`,
      width: `${this.width()}px`,
    };
  }

  height = input<number, string>(0, { transform: numberAttribute });
  width = input<number, string>(0, { transform: numberAttribute });
}
